<template>
    <modal-content @close="$emit('close')">
        <accessory-type-form ref="form" @o3-submit="onSubmit($event)"/>
    </modal-content>
</template>

<script>
import ModalContent from 'domovio-core/src/components/Modal/ModalContent';
import AccessoryTypeForm from '@/modules/ProjectModule/modules/OptionModule/components/Accessory/AccessoryTypeForm';

export default {
    name:       'CreateAccessoryTypeDialog',
    components: {AccessoryTypeForm, ModalContent},
    methods:    {
        onSubmit(data) {
            this.$store.dispatch('projects/project/accessory/createAccessoryType', data)
                .then(() => {
                    this.$refs.form.reset();
                    this.$emit('close');
                }).catch((message) => this.$dmv.notifyError(message));
        }
    }
}
</script>
